import { Box, Button, Skeleton, Typography } from "@mui/material";
import React from "react";

function CallOffSectionSkeleton() {
	return (
		<Box>
			{/* Title */}
			<Typography
				sx={{
					fontFamily: "Roboto",
					fontWeight: 500,
					fontSize: "20px",
					lineHeight: "32px",
					color: "#000000DE",
					padding: "45px 45px 16px 45px",
				}}
			>
				<Skeleton width={320} height={32} />
			</Typography>
			<Box sx={{ padding: "0 45px 20px 45px" }}>
				{/* Shift Details Section */}
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						gap: "24px",
						marginBottom: "20px",
					}}
				>
					<Box sx={{ flex: 1 }}>
						<Typography sx={{ mb: "4px" }}>
							<Skeleton width={80} />
						</Typography>
						<Typography>
							<Skeleton width={220} />
						</Typography>
					</Box>
					<Box sx={{ flex: 1 }}>
						<Typography sx={{ mb: "4px" }}>
							<Skeleton width={120} />
						</Typography>
						<Typography>
							<Skeleton width={180} />
						</Typography>
					</Box>
				</Box>

				{/* Timing Options */}
				<Box sx={{ marginBottom: "32px", display: "flex", gap: "24px" }}>
					<Skeleton variant='rectangular' width={120} height={40} />
					<Skeleton variant='rectangular' width={120} height={40} />
				</Box>

				{/* Duration and Call Off Type */}
				<Box sx={{ display: "flex", gap: "24px", marginBottom: "32px" }}>
					<Box sx={{ flex: 1 }}>
						<Skeleton variant='rectangular' width='100%' height={56} />
					</Box>
					<Box sx={{ flex: 1 }}>
						<Skeleton variant='rectangular' width='100%' height={56} />
					</Box>
				</Box>

				{/* Call Off Reason */}
				<Box sx={{ marginBottom: "16px" }}>
					<Skeleton variant='rectangular' width='100%' height={96} />
				</Box>
			</Box>

			{/* Action Buttons */}
			<Box
				sx={{
					padding: "8px 45px 45px 45px",
					gap: "8px",
					display: "flex",
					justifyContent: "flex-end",
				}}
			>
				<Skeleton
					variant='rectangular'
					width={80}
					height={36}
					sx={{ borderRadius: 1 }}
				/>
				<Skeleton
					variant='rectangular'
					width={160}
					height={36}
					sx={{ borderRadius: 1 }}
				/>
			</Box>
		</Box>
	);
}

export default CallOffSectionSkeleton;
